import { css } from '@emotion/css'
import { spacing, textStyles } from '@offerzen/pinata-shame'

const styles = {
  description: css({
    ...textStyles,
    marginBottom: spacing.medium,
  }),
}

export default styles
